import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconExpandSimple2"><Path fillRule="evenodd" clipRule="evenodd" d="M5.75 12C5.33579 12 5 11.6642 5 11.25V5.75C5 5.33579 5.33579 5 5.75 5H11.25C11.6642 5 12 5.33579 12 5.75C12 6.16421 11.6642 6.5 11.25 6.5H6.5V11.25C6.5 11.6642 6.16421 12 5.75 12ZM12 18.25C12 17.8358 12.3358 17.5 12.75 17.5H17.5V12.75C17.5 12.3358 17.8358 12 18.25 12C18.6642 12 19 12.3358 19 12.75V18.25C19 18.6642 18.6642 19 18.25 19H12.75C12.3358 19 12 18.6642 12 18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple2;
